<template>
  <section>
    <loading-flux :value="loadingActions"></loading-flux>
    <v-row>
      <v-col cols="12" md="12" sm="12">
        <section class="d-flex flex-row flex-sm-row justify-content-between">
          <h4 class="my-3">Listado de Webhooks</h4>
          <section>
              <v-btn
                  @click="openModalFilterWebhooks"
                  color="primary"
                  :dark="false"
                  class="text-white mx-3"
                  >
                  <i class="mdi mdi-filter me-1"></i>
                  Filtros
              </v-btn>
              <v-btn color="primary" @click="openModalCreateWebhook">
                <v-icon small left>
                    mdi-plus
                </v-icon>
                Crear Webhook
              </v-btn>
          </section>
        </section>
      </v-col>
    </v-row>
    <filters
      :modal-action="modalFilter"
      :closeModalFilterWebhooks="closeModalFilterWebhooks"
      @searchFilters="applyFilters"
      @clearAllFilters="clearFilters"
    />
    <v-data-table
      :headers="headers"
      :items="webhooks"
      item-value="id"
      class="elevation-1 mt-4"
      :no-data-text="'No hay webhooks registrados'"
    >
      <template v-slot:item.active="{ item }">
        <v-chip :color="item.active ? 'success' : 'error'" small>
          {{ item.active ? 'Activo' : 'Inactivo' }}
        </v-chip>
      </template>
      <template v-slot:item.secret="{ item }">
        <span class="d-flex align-center">
          <span class="password-text">{{ visibleSecrets[item.id] ? item.secret : '••••••••' }}</span>
          <v-btn icon small @click="toggleSecret(item.id)" class="ml-2">
            <v-icon small>{{ visibleSecrets[item.id] ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
          </v-btn>
        </span>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn icon @click="editWebhook(item)">
          <v-icon color="warning">mdi-pencil</v-icon>
        </v-btn>
        <v-btn icon @click="deleteWebhook(item)">
          <v-icon color="red darken-2">mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <div class="container">
    <h4 class="my-3">Payload del Evento</h4>
    <code-block :code="jsonString" language="json" />
  </div>
    <modal-update-or-create-webhook
      :modal-action="modalWebhook"
      :current-webhook="selectedWebhook"
      :closeModalCreateOrUpdateWebhook="closeModalCreateOrUpdateWebhook"
    />
  </section>
</template>

<script>
import CodeBlock from '@/components/commons/code/CodeBlock.vue';
import Filters from './Filters.vue';
import ModalUpdateOrCreateWebhook from './ModalUpdateOrCreateWebhook.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
  components: { Filters, ModalUpdateOrCreateWebhook, CodeBlock },
  data() {
    return {
      modalWebhook: false,
      modalFilter: false,
      selectedWebhook: null,
      loadingActions: false,
      headers: [
        { text: 'Nombre', value: 'name', align: 'center'},
        { text: 'URL', value: 'url', align: 'center' },
        { text: 'Evento', value: 'event', align: 'center' },
        { text: 'Secret', value: 'secret', align: 'center' },
        { text: 'Activo', value: 'active', align: 'center' },
        { text: 'Acciones', value: 'actions', sortable: false, align: 'center'},
      ],
      visibleSecrets: {},
      filters: {
        search: null,
      },
      jsonString: JSON.stringify({
        event: "user.created",
        data: {
          id: 123,
          name: "John Doe",
          email: "john.doe@example.com"
        }
      }, null, 2)
    };
  },
  mounted() {
    this.fetchWebhooks();
  },
  computed: {
    ...mapGetters({
      webhooks: 'settings/allWebhooks',
    }),
  },
  methods: {
    ...mapActions({
      fetchWebhooks: 'settings/fetchWebhooks',
      sendDeleteWebhook: 'settings/deleteWebhook',
    }),
    applyFilters(filters) {
      console.log('Filters applied:', filters);
    },
    clearFilters() {
      this.filters.search = null;
    },
    openModalFilterWebhooks() {
      this.modalFilter = true;
    },
    closeModalFilterWebhooks() {
      this.modalFilter = false;
    },
    openModalCreateWebhook() {
      this.selectedWebhook = null;
      this.modalWebhook = true;
    },
    editWebhook(webhook) {
      this.selectedWebhook = { ...webhook };
      this.modalWebhook = true;
    },
    async deleteWebhook(webhook) {
      let self = this;
      this.$swal
        .fire({
          icon: "warning",
          title:
            "¿Estás seguro de eliminar el webhook: " +
            webhook.name +
            "?",
          text: "Esta acción no se puede deshacer",
          showCancelButton: true,
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
          confirmButtonColor: "red",
          reverseButtons: true,
        })
        .then(async (result) => {
          if (result.value) {
            this.loadingActions = true;
            const resp = await this.sendDeleteWebhook(webhook.id);
            if (resp.status == 200 || resp.status == 204) {
              this.$swal.fire({
                icon: "success",
                title: "Excelente",
                text:
                  "El webhook: " +
                  webhook.name +
                  " ha sido eliminado correctamente",
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 5000,
                timerProgressBar: true,
              });
            }
            this.loadingActions = false;
          }
        });
    },
    toggleSecret(id) {
      this.$set(this.visibleSecrets, id, !this.visibleSecrets[id]);
    },
    closeModalCreateOrUpdateWebhook() {
      this.modalWebhook = false;
    },
  },
 
};
</script>